import { render, staticRenderFns } from "./DefaultChannelsSection.vue?vue&type=template&id=257bd61f&scoped=true"
import script from "./DefaultChannelsSection.vue?vue&type=script&lang=js"
export * from "./DefaultChannelsSection.vue?vue&type=script&lang=js"
import style0 from "./DefaultChannelsSection.vue?vue&type=style&index=0&id=257bd61f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257bd61f",
  null
  
)

export default component.exports